<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()" [sextant]="'modalSetUserRole'" >
	<div class="form-check form-check-inline">
		<input class="form-check-input" type="checkbox" id="checkbox1" [(ngModel)]="admin">
		<label class="form-check-label" for="checkbox1">Admin</label>
	</div>
	<div class="form-check form-check-inline">
		<input class="form-check-input" type="checkbox" id="checkbox2" [(ngModel)]="accessor">
		<label class="form-check-label" for="checkbox2">Accessor</label>
	</div>
</base-support-modal>
